import React, { useState } from "react";
import DetailsTable from "./DetailsTable";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Table from "../../Table";
import {
  createProductInCartReceived,
  deleteProductItem,
} from "../../../../redux/reducer/productReducer";
import {
  fetchAllCarts,
  OutCartIsReady,
  updateCart,
  updateCartWithImage,
} from "../../../../redux/reducer/cartReducer";
import LoadingSpinner from "../../../animation/LoadingSpinner";

const ReceivedProduct = ({
  data,
  cartID,
  setEditingProducts,
  loading,
  refreshData,
  cartIsPacking,
  cartIsOutCart,
  cartIsReadyToPaid,
  cartStatus,
  cart,
}) => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [pricingOrder, setPricingOrder] = useState(null);
  const [galleryEditingOrder, setGalleryEditingOrder] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showModalAddPackingFees, setShowModalAddPackingFees] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [totalPackingFees, setTotalPackingFees] = useState("");
  const [totalWeightAfterPacking, setTotalWeightAfterPacking] = useState("");
  // console.log(data)
  const headers = [
    "ID",
    "Prod. No",
    "Image",
    "Name",
    "Info",
    "Size",
    "Link",
    "Count",
    "Status",
    "Area",
    "weight",
    "isPacking",
    // 'weight_After',
    "created At",
    "Actions",
  ];

  const handleDelete = (ID) => {
    if (window.confirm("Are you sure you want to delete this Product?")) {
      dispatch(deleteProductItem(ID))
        .unwrap()
        .then(() => {
          if (refreshData) refreshData();
        })
        .catch((error) => alert(error || "Failed to delete order."));
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmitPacking = async () => {
    if (
      window.confirm(`Are you sure the cart has been successfully packaged?`)
    ) {
      try {
        // أولاً: تحديث الكارت
        await dispatch(
          updateCart({
            cartId: cartID,
            data: {
              isReadyToPaid: true,
              totalPackingFees: totalPackingFees,
              totalWeightAfterPacking: totalWeightAfterPacking,
            },
          })
        ).unwrap();

        // Secondly: Upload the image if it exists
        if (selectedImage) {
          await dispatch(
            updateCartWithImage({
              cartId: cartID,
              image: selectedImage,
            })
          ).unwrap();
        }

        // Clear the data and complete the process
        setShowModalAddPackingFees(false);
        setSelectedImage(null);
        setImagePreview(null);
        dispatch(fetchAllCarts());
        setEditingProducts(cartID);
      } catch (error) {
        alert(error || "Failed to update cart.");
      }
    }
  };

  const handleSubmitAddToReceive = () => {
    if (
      window.confirm(
        "Are you sure this cart is ready for payment by the customer?"
      )
    ) {
      // console.log(cartID)
      dispatch(OutCartIsReady(cartID))
        .then(() => {
          dispatch(fetchAllCarts());
          setEditingProducts(cartID);
        })
        .catch((error) => alert(error || "Failed to delete order."));
    }
  };

  const handleAddProduct = () => {
    if (window.confirm("Are you sure you want to Add Product")) {
      dispatch(createProductInCartReceived(cartID))
        .unwrap()
        .then(() => {
          if (refreshData) refreshData();
        })
        .catch((error) => alert(error || "Failed to delete order."));
    }
  };

  const handleUpdate = () => {
    if (refreshData) refreshData();
  };

  if (loading) {
    return <LoadingSpinner />;
  }
  // console.log(data)
  return (
    <>
      <Table
        title={t("Received Products")}
        headers={headers}
        data={data}
        received={true}
        cartIsOutCart={cartIsOutCart}
        onAddProduct={() => handleAddProduct(cartID)}
        EditingProducts={setEditingProducts}
        renderRow={(product, index) => (
          <DetailsTable
            key={product._id || index}
            index={index + 1}
            details={{
              id: product._id,
              number: index + 1,
              Box: product.ReferenceCode,
              link: product.link,
              info: product.additionalInfo,
              Count: product.count,
              history: product.createdAt,
              weight: product.weight || "0.0",
              weightAfterPacking: product.weightAfterPacking || "0.0",
              price: product.price || "00.0",
              status: product.status,
              DShippingFees: product.DShippingFees || "00.0",
              category: product.category,
              brand: product.brand,
              area: product.area,
              currency: product.currency,
              name: product.name,
              image:
                product.img || "https://api.markaship.com/uploads/waiting.png",
              PackingFees: product.PackingFees || "0.0",
              isOutProduct: product.isOutProduct,
              isPacking: product.isPacking,
              images: product.imgs,
              size: product.size,
            }}
            isEditing={editingOrder === product._id}
            isPricing={pricingOrder === product._id}
            isGalleryEditing={galleryEditingOrder === product._id}
            setEditingOrder={setEditingOrder}
            setPricingOrder={setPricingOrder}
            setGalleryEditingOrder={setGalleryEditingOrder}
            onDelete={() => handleDelete(product._id)}
            onUpdate={handleUpdate}
            refreshData={refreshData}
          />
        )}
      />
      {cartIsPacking && !cartIsReadyToPaid && cartStatus === "received" && (
        <>
          <div className="flex justify-end mt-4">
            <button
              disabled={!data.every((product) => product.status === "received")}
              className={`px-4 py-2 rounded font-semibold text-black ${
                data.every((product) => product.status === "received")
                  ? "bg-custom-yellow hover:bg-yellow-600"
                  : "bg-yellow-200 cursor-not-allowed"
              }`}
              onClick={() => setShowModalAddPackingFees(true)}
            >
              {t("Packaging finished")}
            </button>
          </div>
        </>
      )}
      {cartStatus === "outCart" && (
        <>
          <div className="flex justify-end mt-4">
            <button
              disabled={!data.every((product) => product.status === "received")}
              className={`px-4 py-2 rounded font-semibold text-black ${
                data.every((product) => product.status === "received")
                  ? "bg-custom-yellow hover:bg-yellow-600"
                  : "bg-yellow-200 cursor-not-allowed"
              }`}
              onClick={() => handleSubmitAddToReceive()}
            >
              {t("Add to Receive")}
            </button>
          </div>
        </>
      )}

      {showModalAddPackingFees && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-xl max-h-[90vh] overflow-y-auto">
            <h2 className="mb-4 text-lg font-bold text-black">
              {t("Total Packing Fees")}
            </h2>

            {/* Add weight field after packaging */}
            <label className="block mb-2 text-sm font-medium text-gray-700">
              {t("Weight After Packing")}
            </label>
            <input
              type="number"
              value={totalWeightAfterPacking}
              onChange={(e) => setTotalWeightAfterPacking(e.target.value)}
              className="w-full p-2 mb-4 text-black bg-gray-300 rounded"
              placeholder={t("Enter Weight After Packing (KG)")}
            />

            {/* Cost Number Field */}
            <label className="block mb-2 text-sm font-medium text-gray-700">
              {t("Package Fees")}
            </label>
            <input
              type="number"
              value={totalPackingFees}
              onChange={(e) => setTotalPackingFees(e.target.value)}
              className="w-full p-2 mb-4 text-black bg-gray-300 rounded"
              placeholder={t("Enter packing fees")}
            />

            {/* Image selection field */}
            <div className="mb-4">
              <label className="block mb-2 text-sm font-medium text-gray-700">
                {t("Package Image")}
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="w-full p-2 text-black bg-gray-300 rounded file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />

              {/* Display the selected image */}
              {imagePreview && (
                <div className="flex flex-col justify-center mt-3 ">
                  <img
                    src={imagePreview}
                    alt="Package preview"
                    className="flex justify-center object-cover w-1/2 mx-auto border"
                  />
                  <p className="mx-auto mt-1 text-sm text-center text-gray-600 ">
                    {selectedImage.name}
                  </p>
                </div>
              )}
            </div>

            {/* The buttons */}
            <div className="flex justify-end space-x-2">
              <button
                onClick={() => {
                  setShowModalAddPackingFees(false);
                  setSelectedImage(null);
                  setImagePreview(null);
                }}
                className="px-4 py-2 text-black bg-gray-300 rounded hover:bg-gray-400"
              >
                {t("cancel")}
              </button>
              <button
                disabled={!totalPackingFees || !totalWeightAfterPacking}
                onClick={handleSubmitPacking}
                className="px-4 py-2 font-semibold text-black rounded bg-custom-yellow hover:bg-yellow-600 disabled:bg-yellow-200"
              >
                {t("Submit")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReceivedProduct;
